"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const PreviewStarOutlineIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0_3728_2240)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M10.777 4.207L8.96.897C8.581-.3 6.918-.3 6.54.896l-1.816 3.31-3.46.726c-.64.005-1.065.452-1.205.91-.14.455-.04 1.044.444 1.419l2.46 3.042-.435 3.514a1.302 1.302 0 00.449 1.417c.402.31 1.016.39 1.523.011l3.251-1.577 3.252 1.577c.506.38 1.12.299 1.522-.01.397-.306.622-.853.448-1.421l-.673-3.512 2.697-3.04c.486-.375.586-.964.446-1.42-.14-.458-.566-.905-1.205-.91l-3.46-.726zM5.944 5.863L7.75 2.53l1.806 3.334 3.628.713-2.82 3.118.691 3.534-3.305-1.64-3.319 1.647.46-3.542-2.583-3.116 3.636-.714z",
    clipRule: "evenodd"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_3728_2240"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M0 0h16v16H0z"
  })))))
});
PreviewStarOutlineIcon.displayName = 'PreviewStarOutlineIcon';
var _default = exports.default = PreviewStarOutlineIcon;